import { z } from 'zod';

export const formSchema = z.object({
  task: z.string({ required_error: 'Selecione um trabalho' }),
});

export type FormSchema = z.infer<typeof formSchema>;
